import React, { forwardRef } from "react";
import styled, { css } from "styled-components";
import { animationDuration, headerBottomBarHeight, pageGutterSpace, zIndex } from "../../../../settings";
import breakpoint from "../../../../utils/breakpoint";
import getBorderColor from "../../../../utils/getBorderColor";
import getBoxShadow from "../../../../utils/getBoxShadow";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import transition from "../../../../utils/transition";
import unit from "../../../../utils/unit";
import { borderWidthOnBiggerScreen, biggerScreenBreakpoint, getInnerBorderRadius, borderEmphasis } from "../common";
import { headerBackground, headerGap, headerVerticalPaddingSpace } from "./Header.settings";
import HeaderContent from "./HeaderContent";
var StyledHeader = styled.div.withConfig({
  componentId: "sc-duri20-0"
})(function (_ref) {
  var $isSticky = _ref.$isSticky,
    $hasBeenSticky = _ref.$hasBeenSticky,
    $offsetTop = _ref.$offsetTop,
    $minWidth = _ref.$minWidth,
    $tableHorizontalScrollValue = _ref.$tableHorizontalScrollValue,
    $tableWidth = _ref.$tableWidth,
    $onColor = _ref.$onColor,
    $hasHeaderBottomBar = _ref.$hasHeaderBottomBar,
    theme = _ref.theme;
  return css(["display:flex;padding:", " ", " 0;background:", ";box-shadow:", ";> div{display:flex;grid-column-gap:", ";width:100%;", "{> div:first-child p{padding-left:", ";}}}", " ", " ", "{", " > div > :only-child{padding-bottom:", ";}}", "{margin-bottom:", ";padding:0;background:", ";box-shadow:none;", " > div{grid-column-gap:", ";min-height:", ";> :first-child{border-top-left-radius:", ";}> :last-child{border-top-right-radius:", ";}}}"], space(headerVerticalPaddingSpace), space(pageGutterSpace), getColor(theme, headerBackground), getBoxShadow(theme, "small"), unit(headerGap), breakpoint(biggerScreenBreakpoint), space(2), $isSticky && css(["position:fixed;top:", ";z-index:", ";min-width:", ";margin:", " 0 0 ", ";"], $hasHeaderBottomBar ? unit(headerBottomBarHeight) : 0, zIndex.TableMolHeader, $minWidth && unit($minWidth), unit($offsetTop), unit(-1 * $tableHorizontalScrollValue)), $hasBeenSticky && $isSticky && css(["", ";"], transition("margin ".concat(animationDuration.slow / 1000, "s"))), breakpoint("small", biggerScreenBreakpoint), $isSticky && css(["right:0;left:0;"]), space(headerVerticalPaddingSpace), breakpoint(biggerScreenBreakpoint), unit(borderWidthOnBiggerScreen), getBorderColor(theme, $onColor, borderEmphasis), $isSticky && css(["width:calc(", "px - 2 * ", ");> div{border:0 solid ", ";border-width:", " 0;> *{border-radius:0 !important;}}"], $tableWidth, unit(borderWidthOnBiggerScreen), getBorderColor(theme, $onColor, "low"), unit(borderWidthOnBiggerScreen)), unit(borderWidthOnBiggerScreen), space(18), getInnerBorderRadius(theme), getInnerBorderRadius(theme));
});
var Header = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var isSticky = _ref2.isSticky,
    hasBeenSticky = _ref2.hasBeenSticky,
    offsetTop = _ref2.offsetTop,
    minWidth = _ref2.minWidth,
    tableHorizontalScrollValue = _ref2.tableHorizontalScrollValue,
    label = _ref2.label,
    columns = _ref2.columns,
    numberOfColumns = _ref2.numberOfColumns,
    tableWidth = _ref2.tableWidth,
    isBiggerScreen = _ref2.isBiggerScreen,
    onColor = _ref2.onColor,
    hasHeaderBottomBar = _ref2.hasHeaderBottomBar;
  return /*#__PURE__*/React.createElement(StyledHeader, {
    $isSticky: isSticky,
    $hasBeenSticky: hasBeenSticky,
    $offsetTop: offsetTop,
    $minWidth: minWidth,
    $tableHorizontalScrollValue: tableHorizontalScrollValue,
    $tableWidth: tableWidth,
    $onColor: onColor,
    $hasHeaderBottomBar: hasHeaderBottomBar,
    ref: ref
  }, /*#__PURE__*/React.createElement(HeaderContent, {
    label: label,
    columns: columns,
    numberOfColumns: numberOfColumns,
    isBiggerScreen: isBiggerScreen
  }));
});
export default Header;